import React from "react";
import { styled } from "@mui/system";
import MUIChip from "@mui/material/Chip";
import { ChipProps as ChipPropsMUI, ChipTypeMap } from "@mui/material/Chip";
import { OverridableComponent } from "@mui/material/OverridableComponent";
export interface ChipProps extends ChipPropsMUI {
  component?: React.ElementType;
}

const showWarnings = (props) => {
  props.hasOwnProperty("description") &&
    console.warn(
      [
        "Vapor: `description` prop is not supported for Chip component anymore.",
        "",
        "You can check and use VaporTag at `@vapor/react-custom`.",
        "",
        "For more information you may look over Vapor Custom https://biosphere.teamsystem.com/vapor/react/vapor-custom/-/blob/main/CHANGELOG.md."
      ].join("\n")
    );
  props.hasOwnProperty("type") &&
    console.warn(
      [
        "Vapor: `type` prop is not supported for Chip component anymore.",
        "",
        "You can check and use VaporTag at `@vapor/react-custom`.",
        "",
        "For more information you may look over Vapor Custom https://biosphere.teamsystem.com/vapor/react/vapor-custom/-/blob/main/CHANGELOG.md."
      ].join("\n")
    );
  props.hasOwnProperty("variant") &&
    props.variant === "default" &&
    console.warn(
      [
        "Vapor: `default` variant is not supported for Chip component anymore.",
        "",
        "You can check and use VaporTag at `@vapor/react-custom`.",
        "",
        "For more information you may look over Vapor Custom https://biosphere.teamsystem.com/vapor/react/vapor-custom/-/blob/main/CHANGELOG.md."
      ].join("\n")
    );
  props.hasOwnProperty("variant") &&
    props.variant === "standard" &&
    console.warn(
      [
        "Vapor: `standard` variant is not supported for Chip component anymore.",
        "",
        "You can check and use VaporTag at `@vapor/react-custom`.",
        "",
        "For more information you may look over Vapor Custom https://biosphere.teamsystem.com/vapor/react/vapor-custom/-/blob/main/CHANGELOG.md."
      ].join("\n")
    );
  props.hasOwnProperty("variant") &&
    props.variant === "ghost" &&
    console.warn(
      [
        "Vapor: `ghost` variant is not supported for Chip component anymore.",
        "",
        "You can check and use VaporTag at `@vapor/react-custom`.",
        "",
        "For more information you may look over Vapor Custom https://biosphere.teamsystem.com/vapor/react/vapor-custom/-/blob/main/CHANGELOG.md."
      ].join("\n")
    );
};

const ChipRoot = styled(
  React.forwardRef<HTMLDivElement, ChipProps>((props, ref) => {
    showWarnings(props);
    return <MUIChip ref={ref} {...props} />;
  }),
  {
    name: "Chip",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiChip-root": {
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    paddingRight: 6,
    background:
      theme.name === "fic"
        ? theme.palette.primary.neutral3
        : theme.palette.primary.background,
    border: "1px solid transparent",
    "&:hover": {
      background:
        theme.name === "fic"
          ? theme.palette.primary.neutral10Color
          : theme.palette.primary.interactiveSelectedColor,
      "& .MuiChip-label": {
        color: theme.palette.primary.textTitleColor
      },
      "& .MuiSvgIcon-root": {
        color: theme.palette.primary.textTitleColor,
        fontSize: 20
      }
    },
    "&:active": {
      boxShadow: "none",
      border: "1px solid " + theme.palette.primary.borderActive,
      background: theme.palette.primary.interactiveSelectedColor,
      "& .MuiChip-label": {
        fontweight: 500,
        fontSize: 14,
        color: theme.palette.primary.textTitleColor
      },
      "& .MuiSvgIcon-root": {
        color: theme.palette.primary.textTitleColor
      }
    }
  },
  "&.MuiChip-root .MuiSvgIcon-root": {
    color: theme.palette.primary.textSubduedColor
  },
  "&.MuiChip-root .MuiChip-deleteIcon": {
    fontSize: 20
  },
  "&.MuiChip-root .MuiChip-icon": {
    fontSize: 14
  },
  "&.MuiChip-root .MuiChip-label":
    theme.name === "fic"
      ? {
          ...theme.typography["body500"],
          fontWeight: 500,
          color: theme.palette.primary.textSubduedColor
        }
      : {
          fontFamily: "Roboto",
          fontSize: 14,
          fontWeight: 500,
          color: theme.palette.primary.textSubduedColor
        },

  "&.MuiChip-root.MuiChip-outlinedDefault": {
    border:
      theme.name === "fic"
        ? "1px solid #008BCC"
        : "1px solid " + theme.palette.primary.borderActive,
    background: theme.palette.primary.interactiveSelectedColor,
    "& .MuiChip-label": {
      fontweight: 500,
      fontSize: 14,
      color: theme.palette.primary.textTitleColor,
      paddingLeft: 12,
      paddingRight: 12
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.primary.textTitleColor
    }
  }
}));

export const Chip = React.forwardRef<HTMLDivElement, ChipProps>(function Chip(
  props,
  ref
) {
  return <ChipRoot {...props} ref={ref} />;
}) as OverridableComponent<ChipTypeMap<{}, "div">>;
